import { createTheme } from "@mui/material"

const defaultDarkTheme = createTheme( {
    palette: {
        mode: 'dark'
    }
} )

export default defaultDarkTheme